<script>
import {Pie} from "vue-chartjs";
import {mapActions, mapGetters} from "vuex";

export default {
  extends: Pie,
  computed:{
    ...mapGetters(['data_pie_chart_square_categories', 'square_category_colors'])
  },
   async mounted() {
    await this.fetchSquarePayments()
    await this.renderChart(
        {
          labels: Object.keys(this.data_pie_chart_square_categories),
          datasets: [
            {
              backgroundColor: this.square_category_colors,
              data: Object.values(this.data_pie_chart_square_categories)
            }
          ],
        },
        {
          legend: {
            position: 'top'
          },
          responsive: true,
          maintainAspectRatio: false,
          tooltips: {
            callbacks: {
              label: function(tooltipItem, data) {
                var dataset = data.datasets[tooltipItem.datasetIndex];
                var labels = data.labels
                var total = dataset.data.flat().reduce(function(previousValue, currentValue, currentIndex, array) {
                  return previousValue + currentValue;
                });
                var current_Label = labels[tooltipItem.index]
                var currentValue = dataset.data[tooltipItem.index];
                var precentage = Math.floor(((currentValue/total) * 100)+0.5);
                return  current_Label + ": "+precentage + "% " + "(" + currentValue + ")";
              }
            }
          }
        }
    );
  },
  methods:{
    ...mapActions('sale_manager', ['fetchSquarePayments'])
  }
};
</script>
